<template>
  <div>

    <table-manager
      @filterChanged="filterChanged"
      @paginationChanged="paginationChanged"

      :options="options"
      />

    <basic-table
    :key="rerenderTable"
      v-if="buildingsList"
      :items="buildingsList"
      :fields="houseFields"
      :filter="filter"
      :filterFunction="function(row,filter){return true}"
      :perPage="perPage"
      :totalRows="totalRows"
      @RowSelected="rowHouseClickHandler"
      @onRowDoubleClick="onRowDoubleClick"
      isEdit="false"
      isDelete="false"/>
    <table-manager-bottom
      :totalRows="totalRows"
       :perPage="perPage"
       @input="onClickPageChange"
      v-model="currentPage"/>

    <modal-ok-cancel @save="selectHouse" @cancel="hideFormHouse" buttonSaveLabel="Ok" size="lg"/>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: null
  },
  data () {
    return {
      rerenderTable: 0,
      selectedHouse: null,
      houseFields: [
        {key: 'house_id', label: 'ID', sortable: true},
        {key: 'zones', label: this.$i18n.t('IP zone ID'), sortable: true},
        {key: 'connect_date', label: this.$i18n.t('Connected on'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'post_code', label: this.$i18n.t('ZIP code'), sortable: true},
        {key: 'country', label: this.$i18n.t('Country'), sortable: true, formatter: (val) => { return this.splitLongString(val) }},
        {key: 'region', label: this.$i18n.t('Province/State'), sortable: true, formatter: (val) => { return this.splitLongString(val) }},
        {key: 'city', label: this.$i18n.t('City'), sortable: true, formatter: (val) => { return this.splitLongString(val) }},
        {key: 'street', label: this.$i18n.t('Street'), sortable: true, formatter: (val) => { return this.splitLongString(val) }},
        {key: 'number', label: this.$i18n.t('Building#'), sortable: true},
        {key: 'building', label: this.$i18n.t('Constr.#'), sortable: true},
        {key: 'description', label: this.$i18n.t('Description'), sortable: true, formatter: (val) => { return this.splitLongString(val) }}
      ],
      options: {
        isDisablePerShow: true,
        isShowAddButton: false,
        placeholder: this.$i18n.t('ID, Postal, Country...')
      },
      filter: '',
      perPage: 25,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    splitLongString (val) {
      let result = val.charAt(0)
      for (let i = 1; i < val.length; i++) {
        result += val.charAt(i)
        if (i % 10 === 0) {
          result += '\n'
        }
      }
      return result
    },
    onRowDoubleClick (item, index, event) {
      if (this.selectedHouse) {
        this.selectedHouse._rowVariant = ''
      }
      this.selectedHouse = item
      this.$set(this.selectedHouse, '_rowVariant', 'info')
      this.selectHouse()
    },
    selectHouse () {
      if (!this.selectedHouse) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select house'), 'Error')
        return
      }
      this.$emit('input', this.selectedHouse.house_id)
      this.$emit('hideFormHouse')
    },
    hideFormHouse () {
      this.$emit('hideFormHouse')
    },
    onClickPageChange (val) {
      this.currentPage = val
      this.load()
    },
    rowHouseClickHandler (row) {
      if (this.selectedHouse) {
        this.selectedHouse._rowVariant = ''
      }
      this.selectedHouse = row
      this.$set(this.selectedHouse, '_rowVariant', 'info')
    },
    filterChanged (value) {
      this.filter = value
      this.currentPage = 1
      this.$store.dispatch('ReferenceBooks/GET_BUILDINGS_PARAMS', {filter: this.filter, per_page: this.perPage, page: this.currentPage})
    },
    paginationChanged (value) {
      this.perPage = value
      this.currentPage = 1
      this.load()
    },
    async load () {
      await this.$store.dispatch('ReferenceBooks/GET_BUILDINGS_PARAMS', {filter: this.filter, per_page: this.perPage, page: this.currentPage})
      this.rerenderTable += 1
    }
  },
  watch: {
    buildingsList: function (val) {
      this.totalRows = this.$store.getters['ReferenceBooks/BUILDINGS_PAGED'].total_rows
      this.rerenderTable += 1
    }
  },
  mounted () {
    this.load()
  },
  computed: {
    buildingsList () {
      return this.$store.getters['ReferenceBooks/BUILDINGS_PAGED'].houses
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/contacts/formHouse.vue